import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Trash2, Eye, Search, BookOpen, X, Save, Globe, Lock } from 'lucide-react';
import api from '../../services/api';
import { toast } from 'react-toastify';

export default function KnowledgeBasePage() {
  const [articles, setArticles] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ title: '', content: '', category: '', tags: '', isPublished: true });
  const [search, setSearch] = useState('');
  const [viewArticle, setViewArticle] = useState(null);

  useEffect(() => { loadArticles(); }, []);

  const loadArticles = async () => {
    try { const res = await api.get('/knowledge-base'); setArticles(res.data); } catch (err) {}
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await api.put(`/knowledge-base/${editId}`, form);
        toast.success('Makale güncellendi');
      } else {
        await api.post('/knowledge-base', form);
        toast.success('Makale oluşturuldu');
      }
      setShowForm(false); setEditId(null);
      setForm({ title: '', content: '', category: '', tags: '', isPublished: true });
      loadArticles();
    } catch (err) { toast.error('Hata'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Makaleyi silmek istediğinize emin misiniz?')) return;
    await api.delete(`/knowledge-base/${id}`);
    toast.success('Silindi'); loadArticles();
  };

  const handleEdit = (a) => {
    setEditId(a.Id);
    setForm({ title: a.Title, content: a.Content, category: a.Category || '', tags: a.Tags || '', isPublished: a.IsPublished });
    setShowForm(true);
  };

  const filtered = articles.filter(a => {
    if (search && !a.Title.toLowerCase().includes(search.toLowerCase()) && !(a.Tags || '').toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Bilgi Bankası</h1>
          <p className="text-sm text-slate-500 mt-1">Çözüm makaleleri ve SSS</p>
        </div>
        <button onClick={() => { setShowForm(true); setEditId(null); setForm({ title: '', content: '', category: '', tags: '', isPublished: true }); }}
          className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700">
          <Plus size={16} /> Yeni Makale
        </button>
      </div>

      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3 top-3 text-slate-400" />
        <input type="text" value={search} onChange={e => setSearch(e.target.value)}
          className="pl-9 pr-4 py-2.5 w-full border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Makale ara..." />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map(a => (
          <div key={a.Id} className="bg-white rounded-xl shadow-sm border border-slate-100 p-5 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center gap-2">
                <BookOpen size={16} className="text-blue-500" />
                <h3 className="text-sm font-semibold text-slate-800 line-clamp-1">{a.Title}</h3>
              </div>
              {a.IsPublished ? <Globe size={14} className="text-emerald-500" title="Yayında" /> : <Lock size={14} className="text-slate-400" title="Taslak" />}
            </div>
            {a.Category && <span className="text-xs bg-blue-50 text-blue-600 px-2 py-0.5 rounded-full">{a.Category}</span>}
            <p className="text-xs text-slate-500 mt-2 line-clamp-2">{a.Content.substring(0, 120)}...</p>
            {a.Tags && <div className="flex flex-wrap gap-1 mt-2">{a.Tags.split(',').map((t, i) => <span key={i} className="text-xs bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded">{t.trim()}</span>)}</div>}
            <div className="flex items-center justify-between mt-3 pt-3 border-t border-slate-100">
              <span className="text-xs text-slate-400"><Eye size={12} className="inline" /> {a.ViewCount} görüntülenme</span>
              <div className="flex gap-1">
                <button onClick={() => setViewArticle(a)} className="p-1.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg"><Eye size={14} /></button>
                <button onClick={() => handleEdit(a)} className="p-1.5 text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg"><Edit2 size={14} /></button>
                <button onClick={() => handleDelete(a.Id)} className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p className="col-span-full text-center text-slate-400 py-10">Henüz makale oluşturulmamış</p>}
      </div>

      {/* View Article Modal */}
      {viewArticle && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between px-6 py-4 border-b sticky top-0 bg-white">
              <h3 className="text-lg font-semibold text-slate-800">{viewArticle.Title}</h3>
              <button onClick={() => setViewArticle(null)} className="p-1 text-slate-400 hover:text-slate-600"><X size={20} /></button>
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                {viewArticle.Category && <span className="text-xs bg-blue-50 text-blue-600 px-2 py-0.5 rounded-full">{viewArticle.Category}</span>}
                <span className="text-xs text-slate-400">{viewArticle.AuthorName} • {new Date(viewArticle.CreatedAt).toLocaleDateString('tr-TR')}</span>
              </div>
              <div className="prose prose-sm max-w-none text-slate-700 whitespace-pre-wrap">{viewArticle.Content}</div>
            </div>
          </div>
        </div>
      )}

      {/* Create/Edit Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between px-6 py-4 border-b sticky top-0 bg-white z-10">
              <h3 className="text-lg font-semibold text-slate-800">{editId ? 'Makale Düzenle' : 'Yeni Makale'}</h3>
              <button onClick={() => setShowForm(false)} className="p-1 text-slate-400 hover:text-slate-600"><X size={20} /></button>
            </div>
            <form onSubmit={handleSave} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Başlık *</label>
                <input type="text" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} required
                  className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Kategori</label>
                  <input type="text" value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}
                    className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="E-Fatura" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Etiketler (virgülle)</label>
                  <input type="text" value={form.tags} onChange={e => setForm({ ...form, tags: e.target.value })}
                    className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="fatura, logo, hata" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">İçerik *</label>
                <textarea value={form.content} onChange={e => setForm({ ...form, content: e.target.value })} rows={12} required
                  className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm resize-none" />
              </div>
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" checked={form.isPublished} onChange={e => setForm({ ...form, isPublished: e.target.checked })}
                  className="w-4 h-4 rounded border-slate-300 text-blue-600" />
                <span className="text-sm text-slate-700">Müşterilere görünür (yayında)</span>
              </label>
              <button type="submit"
                className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-semibold hover:from-blue-700 hover:to-blue-800 flex items-center justify-center gap-2">
                <Save size={18} /> {editId ? 'Güncelle' : 'Oluştur'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
